import { type BrandType } from '@/defs/brand'

export const EU_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'JP', // TODO: Confirm Japan?
  'LI',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
]

export const PRICE_SOURCES = [
  'cardhoarder',
  'cardkingdom',
  'cardmarket',
  'cardsphere',
  'cardtrader',
  'face2face',
  'manapool',
  'mtgstocks',
  'scg',
  'tcgplayer',
] as const satisfies readonly BrandType[]
export type PriceSourceType = (typeof PRICE_SOURCES)[number]
export const isPriceSourceType = (slug?: string): slug is PriceSourceType =>
  PRICE_SOURCES.includes(slug as PriceSourceType)

export const PRICE_SOURCE_CURRENCIES: Record<PriceSourceType, 'dollar' | 'euro' | 'tix'> = {
  cardhoarder: 'tix',
  cardkingdom: 'dollar',
  cardmarket: 'euro',
  cardsphere: 'dollar',
  cardtrader: 'euro',
  face2face: 'dollar',
  manapool: 'dollar',
  mtgstocks: 'dollar',
  scg: 'dollar',
  tcgplayer: 'dollar',
}

export const DEFAULT_PRICE_SOURCES: readonly PriceSourceType[] = [
  'cardkingdom',
  'tcgplayer',
  'manapool',
  'scg',
  'face2face',
  'cardmarket',
  'cardtrader',
  'cardhoarder',
]
export const DEFAULT_PRICE_SOURCES_CA: readonly PriceSourceType[] = [
  'face2face',
  'cardkingdom',
  'tcgplayer',
  'manapool',
  'scg',
  'cardmarket',
  'cardtrader',
  'cardhoarder',
]
export const DEFAULT_PRICE_SOURCES_EU: readonly PriceSourceType[] = [
  'cardtrader',
  'cardmarket',
  'tcgplayer',
  'cardkingdom',
  'manapool',
  'scg',
  'face2face',
  'cardhoarder',
]

export type PriceSourceMapType = Partial<Record<PriceSourceType, { price?: number; slug?: string }>>
